export enum IntervalE {
  MONTHLY = 'Monthly',
  YEARLY = 'Yearly'
}

export enum AuthProviderE {
  EMAIL = 'email',
  GOOGLE = 'google',
  RESEND = 'resend',
  LINKEDIN = 'linkedin'
}

export enum RolesE {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
  PARTICIPANT = 'PARTICIPANT'
}

export enum Actions {
  CREATE = 'create',
  READ = 'read',
  UPDATE = 'update',
  DELETE = 'delete',
  MANAGE = 'manage'
}

export enum Subjects {
  SUBSCRIPTION = 'Subscription',
  ORG = 'Org',
  TODO = 'Todo',
  USER = 'User',
  PROJECT = 'Project',
  ALL = 'all'
}
